import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

const FormRow = ({ label, children }) => (
  <div className="row">
    <div className="col-md-3 col-lg-3 text-left text-md-left">
      <label className="mb-0">{label}</label>
    </div>
    <div className="col-md-9 col-lg-6 form-group">
      {children}
    </div>
  </div>
);

const DisabledInput = ({ id, name, value, placeholder }) => (
  <InputText
    id={id}
    name={name}
    value={value}
    tagClass="form-control mb-0"
    placeholder={placeholder}
    className="w-100"
    disabled
  />
);

const DisabledTextarea = ({ id, name, value, rows = 3 }) => (
  <InputTextarea
    id={id}
    name={name}
    value={value}
    className="w-100"
    tagClass="form-control"
    placeholder=""
    rows={rows}
    disabled
  />
);

const ProductUnitInfo = ({ form_data }) => {
  const [has_polarcare, setHasPolarCare] = useState(false);

  useEffect(() => {
    setHasPolarCare(Boolean(form_data.polarcare_plus));
  }, [form_data]);

  return (
    <div>
      <FormRow label="QR Code">
        <DisabledInput id="qr_code" name="qr_code" value={form_data.qr_code} placeholder="QR Code" />
      </FormRow>

      <FormRow label="Customer">
        <DisabledInput id="customer_name" name="customer_name" value={form_data.customer_name} placeholder="Customer" />
      </FormRow>

      <FormRow label="Reference No">
        <DisabledInput id="order_no" name="order_no" value={form_data.order_no} placeholder="Reference No" />
      </FormRow>

      <FormRow label="Purchased Date">
        <DisabledInput id="purchased_date" name="purchased_date" value={form_data.purchased_date} placeholder="Purchased Date" />
      </FormRow>

      <FormRow label="Brand">
        <DisabledInput id="brand_name" name="brand_name" value={form_data.brand_name} placeholder="Brand" />
      </FormRow>

      <FormRow label="Model">
        <DisabledInput id="model" name="model" value={form_data.model} placeholder="Model" />
      </FormRow>

      <FormRow label="Indoor Serial No">
        <DisabledInput id="indoor_serial" name="indoor_serial" value={form_data.indoor_serial} placeholder="Indoor Serial No" />
      </FormRow>

      <FormRow label="Outdoor Serial No">
        <DisabledInput id="outdoor_serial" name="outdoor_serial" value={form_data.outdoor_serial} placeholder="Outdoor Serial No" />
      </FormRow>

      <FormRow label="Cleaning Cycle Days">
        <InputText
          name="cleaning_cycle_days"
          value={form_data.cleaning_cycle_days}
          inputClassName="form-control"
          placeholder="Days"
          className="w-100"
          disabled
        />
      </FormRow>

      <FormRow label="Unit Location">
        <DisabledInput id="unit_location" name="unit_location" value={form_data.unit_location} placeholder="Unit Location" />
      </FormRow>

      <FormRow label="Remarks">
        <DisabledTextarea id="remarks" name="remarks" value={form_data.remarks} />
      </FormRow>

      <div className="row">
        <div className="col-12"><hr /></div>
      </div>

      <FormRow label="PolarCare+">
        <DisabledInput id="polarcare" name="polarcare" value={has_polarcare ? 'Yes' : 'No'} placeholder="PolarCare+" />
      </FormRow>

      {has_polarcare && (
        <FormRow label="Start Date">
          <DisabledInput id="polarcare_start_date" name="polarcare_start_date" value={form_data.polarcare_start_date} placeholder="Start Date" />
        </FormRow>
      )}
    </div>
  );
};

export default ProductUnitInfo;